import { TransactionTypeResponse } from '../../../../web-api-client';
import { transactionTypeItems } from '../../constants/transaction-type-items';
import { TransactionType } from '../../models/transaction-type';

export const mapTransactionTypeFromResponse = (
  response: TransactionTypeResponse
): TransactionType => ({
  transactionTypeId: response.transactionTypeId!,
  name: (transactionTypeItems.find(x => x.value === response.transactionTypeId)
    ?.label || response.name)!,
  description: response.description!,
  isActive: response.isActive ?? false,
});
